import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import 'rxjs/add/operator/map';
import { AngularFire, FirebaseListObservable } from 'angularfire2';

export class group {
    name: string;
    parentGroup: string;
    visibility: string;
    admins: Array<any>;
    members:Array<any>;
    whatup: string;
    facebooklink: string;
    $key: string;
    checkedState: boolean;
}
@Injectable()
export class groupModel {
    groupsRef: FirebaseListObservable<any>;
    groups: Array<group>;
    constructor(
        private af: AngularFire,
        public platform: Platform
    ) {
        var that = this;
        this.platform.ready().then(() => {     

            that.groupsRef = af.database.list('/Group');
            that.groupsRef.subscribe(obj => {
                console.log(obj);
                that.groups = obj;
            });
        });
    }

}



// WEBPACK FOOTER //
// ./src/model/groupModel.ts